import type { CategorySplit } from "@/lib/skills/analytics";
import { categoryMeta } from "@/lib/skills/constants";

export function DownloadsByCategoryBars({ splits }: { splits: CategorySplit[] }) {
  return (
    <div className="rounded-[12px] border border-border-1 bg-bg-1 p-6 shadow-xs">
      <h3 className="mb-6 font-display text-[17px] font-semibold text-navy">
        Downloads by category
      </h3>
      <div className="flex flex-col gap-5">
        {splits.map((split) => (
          <div key={split.category}>
            <div className="mb-2 flex items-center justify-between text-[13px]">
              <span className="font-semibold text-fg-1">{split.category}</span>
              <span className="text-fg-3">
                {split.downloads.toLocaleString()} · {split.pct}%
              </span>
            </div>
            <div className="h-2.5 w-full overflow-hidden rounded-full bg-bg-3">
              <div
                className="h-full rounded-full transition-[width] duration-300 ease-out"
                style={{
                  width: `${split.pct}%`,
                  backgroundColor: categoryMeta(split.category).tint,
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
